import React, { useMemo } from 'react'
import { useState, useEffect } from "react"
import axios from "axios"
import { motion, AnimatePresence } from "framer-motion"
import { Plus, Edit, Trash2, Save, X, Building2, ImageIcon, Eye, EyeOff, UserCheck, Filter, Phone } from "lucide-react"
import { tactosDeleteIdea } from '../utils/api'
import { toast } from 'react-toastify'

const StartupIdeas = () => {
  const [investors, setInvestors] = useState([])
  const [showForm, setShowForm] = useState(false)
  const [formData, setFormData] = useState({})
  const [editingId, setEditingId] = useState(null)
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
  const [deleteId, setDeleteId] = useState(null)
  const [toggle, setToggle] = useState(false)
  const [loading, setLoading] = useState(false)

  // NEW: track which investor is being processed for active toggle
  const [processingId, setProcessingId] = useState(null)


  const fetchApplications = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/getallstartup/idea`)
      setInvestors(res.data.data)
      console.log(res)
    } catch (error) {
      console.error("Error fetching investors:", error)
    }
  }

  // Fetch toggle state
  const fetchToggleState = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/investortoggle`)
      setToggle(res.data.enabled)
    } catch (error) {
      console.error("Error fetching toggle state:", error)
    }
  }

const HIDDEN_FIELDS = [
  "_id",
  "__v",
  "createdAt",
  "updatedAt",
  "paymentOrderId",

  // hide file metadata
  "videoPitchFileName",
  "videoPitchFileType",
  "pitchDeckFileName",
  "pitchDeckFileType",
  "cvFileName",
  "cvFileType"
];

const displayFields = Object.entries(formData || {}).filter(
  ([key, value]) =>
    !HIDDEN_FIELDS.includes(key) &&
    value !== null &&
    value !== "" &&
    value !== false
);
 const formatLabel = (key) =>
  key
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (c) => c.toUpperCase());


  useEffect(() => {
    fetchApplications()
    fetchToggleState()
  }, [])
  const [activeTab, setActiveTab] = useState("startup-idea")

  const filteredEvents = useMemo(() => {
  return investors.filter((each) => each.programType === activeTab)
}, [investors, activeTab]);

  const tabVariants = {
    inactive: { scale: 1, opacity: 0.7 },
    active: { scale: 1.05, opacity: 1 },
  }
  const handleTabChange = (tab) => setActiveTab(tab)


  const handleEdit = (investor) => {
    console.log(investor)
    setFormData(investor)
    setEditingId(investor._id)
    setShowForm(true)
  }

  const handleDeleteConfirm = (id) => {
    setShowDeleteConfirm(true)
    setDeleteId(id)
  }

  const handleDelete = async (id) => {
    console.log(id)
    try {
      await tactosDeleteIdea(id)
      toast("Startup Idea Removed")
      setShowDeleteConfirm(false)
      setDeleteId(null)
      fetchApplications()
    } catch (error) {
      console.error("Error deleting Application:", error)
    }
  }

  const getTypeColor = (type) => {
    switch (type) {
      case "Our Key Partner":
        return "bg-purple-100 text-purple-800 border-purple-200"
      case "Our Partner":
        return "bg-blue-100 text-blue-800 border-blue-200"
      case "Our Investor":
        return "bg-green-100 text-green-800 border-green-200"
      default:
        return "bg-gray-100 text-gray-800 border-gray-200"
    }
  }

  const openNewForm = () => {
    setFormData({ type: "", name: "", image: "" })
    setEditingId(null)
    setShowForm(true)
  }

  const handleFormSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {

      setFormData({ type: "", name: "", image: "" })
      setShowForm(false)
      setEditingId(null)
      fetchApplications()
    } catch (error) {
      console.error("Error submitting form:", error)
    } finally {
      setLoading(false)
    }
  }
const isMediaField = (value) => {
  return (
    typeof value === "string" &&
    (
      value.startsWith("data:image") ||
      value.startsWith("data:video") ||
      value.startsWith("data:application/pdf")
    )
  );
};

const openBase64InNewTab = (base64) => {
  const [meta, data] = base64.split(",");
  const mime = meta.match(/:(.*?);/)[1];

  const byteCharacters = atob(data);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const blob = new Blob([new Uint8Array(byteNumbers)], { type: mime });
  const blobUrl = URL.createObjectURL(blob);

  window.open(blobUrl, "_blank");
};


const isUrl = (value) => {
  return (
    typeof value === "string" &&
    (value.startsWith("http://") || value.startsWith("https://"))
  );
};


  const renderFilePreview = (value, key) => {
  if (typeof value !== "string") return null;

  // 🖼 IMAGE
  if (value.startsWith("data:image")) {
    return (
  
  <img
  onClick={() => openBase64InNewTab(value)}
    src={value}
    alt={key}
    className="w-full max-h-64 rounded-lg border hover:opacity-90 transition"
  />



    );
  }

  // 📄 PDF
  if (value.startsWith("data:application/pdf")) {
    return (
     <div
      className="relative w-full h-64 rounded-lg border cursor-pointer group"
      onClick={() => openBase64InNewTab(value)}
    >
      <iframe
        src={value}
        title={key}
        className="w-full h-full rounded-lg pointer-events-none"
      />

      {/* Overlay */}
      <div className="
        absolute inset-0 bg-black/30 opacity-0
        group-hover:opacity-100
        flex items-center justify-center
        text-white font-semibold text-sm
        transition
      ">
        Click to open PDF
      </div>
    </div>
    );
  }

  // 🎥 VIDEO
  if (value.startsWith("data:video")) {
    return (
      <video
        src={value}
        controls
        className="w-full max-h-64 rounded-lg border"
      />
    );
  }

  // ⬇️ Fallback (download)
  return (
    <a
      href={value}
      download={formData[`${key}Name`] || "file"}
      target="_blank"
      rel="noreferrer"
      className="px-4 py-3 rounded-lg border bg-blue-50 text-blue-600 font-medium hover:underline"
    >
      Download {formatLabel(key)}
    </a>
  );
};

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="w-full mx-auto p-6">
        {/* Header */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center">
                <Building2 className="w-6 h-6 text-white" />
              </div>
              <div>
                <h1 className="text-3xl font-bold text-gray-900">Startup Ideas</h1>
                <p className="text-gray-500">
                  Review and manage submitted startup ideas, founder details, and application insights.
                </p>
              </div>

            </div>


          </div>
        </div>

       <motion.div
  initial={{ opacity: 0, y: 20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ delay: 0.1 }}
  className="flex flex-wrap gap-3 mb-8 p-2 bg-white rounded-2xl"
>
  {[
    { label: "Startup Idea", dblabel: "startup-idea" },
    { label: "Student Ambassador", dblabel: "student-ambassador" },
    { label: "Residency Program", dblabel: "residency-program" },
    { label: "Business Consultation", dblabel: "business-consultation" },
    { label: "Investment Readiness", dblabel: "investment-readiness" }
  ].map((tab, index) => (
    <motion.button
      key={index}
      variants={tabVariants}
      animate={activeTab === tab.dblabel ? "active" : "inactive"}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={() => handleTabChange(tab.dblabel)}
      className={`px-6 py-3 rounded-xl text-sm font-semibold flex items-center gap-2 ${
        activeTab === tab.dblabel
          ? "bg-gradient-to-r from-blue-600 to-purple-600 text-white"
          : "bg-white text-gray-700 hover:bg-gray-50"
      }`}
    >
      <Filter className="text-sm" />
      {tab.label} 
    </motion.button>
  ))}
</motion.div>


        {/* Status Banner */}


        {/* Investors Grid */}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <AnimatePresence>
            {filteredEvents.length === 0 ? (
              <div className="col-span-full flex flex-col items-center justify-center py-16">
                <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-6">
                  <Building2 className="w-12 h-12 text-gray-400" />
                </div>
                <h3 className="text-xl font-semibold text-gray-700 mb-2">0 application Found</h3>

                {/* <button
                    onClick={openNewForm}
                    className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors flex items-center gap-2"
                  >
                    <Plus className="w-4 h-4" />
                    Add First Investor
                  </button> */}
              </div>
            ) : (
              filteredEvents.map((investor, index) => (
                <motion.div
                  key={investor._id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ delay: index * 0.1 }}
                  className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-all duration-300"
                >
                  <div className="flex items-start gap-4 mb-4">
                    <div className="w-16 h-16 rounded-xl overflow-hidden border-2 border-gray-200 flex-shrink-0">
                      {investor.image ? (
                        <img
                          src={investor.image || "/placeholder.svg"}
                          alt={investor.name}
                          className="w-full h-full object-cover"
                          onError={(e) => {
                            e.target.style.display = "none"
                            e.target.nextSibling.style.display = "flex"
                          }}
                        />
                      ) : null}
                      <div className="w-full h-full bg-gray-100 flex items-center justify-center">
                        <ImageIcon className="w-6 h-6 text-gray-400" />
                      </div>
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-lg font-semibold text-gray-900 truncate">{investor.name||investor.founderName}</h3>
                      <div className="flex items-center gap-3 mt-1">
                        <div className="flex items-center gap-3 mt-1">
                          <p className="flex text-sm items-center font-medium text-blue-600 bg-blue-50 px-3 py-1 rounded-md shadow-sm">
                           {investor.startupName ? (
  investor.startupName
) : (
  <>
    <Phone className='h-4'/> {investor.phone}
  </>
)}

                          </p>
                        </div>
                        {/* Active / Inactive status badge */}

                      </div>
                    </div>
                  </div>

                  <div className="flex gap-2">
                    <button
                      onClick={() => handleEdit(investor)}
                      className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors"
                    >
                      <Eye className="w-3 h-3" />
                      View
                    </button>

                    <button
                      onClick={() => handleDeleteConfirm(investor._id)}
                      className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors"
                    >
                      <Trash2 className="w-3 h-3" />
                      Delete
                    </button>

                  </div>
                </motion.div>
              ))
            )}
          </AnimatePresence>
        </div>


      </div>

      {/* Form Modal */}
      <AnimatePresence>
        {showForm && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
            onClick={() => setShowForm(false)}
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.95, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95, y: 20 }}
              transition={{ type: "spring", damping: 20, stiffness: 300 }}
              className="bg-white dark:bg-slate-950 rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto border border-gray-200 dark:border-slate-800"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header */}
              <div className="sticky top-0 p-6 border-b border-gray-200 dark:border-slate-800 flex items-center justify-between bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-slate-900 dark:to-slate-800 rounded-t-2xl">
                <div>
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Application Details</h2>
                  <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                    Review the submitted application information
                  </p>
                </div>
                <button
                  onClick={() => setShowForm(false)}
                  className="w-10 h-10 bg-white dark:bg-slate-800 hover:bg-gray-100 dark:hover:bg-slate-700 rounded-full flex items-center justify-center transition-all shadow-md hover:shadow-lg"
                >
                  <X className="w-5 h-5 text-gray-600 dark:text-gray-300" />
                </button>
              </div>

              {/* Form Content */}
              <div className="p-8">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

{displayFields.map(([key, value]) => {
  const isMedia =
    typeof value === "string" &&
    (
      value.startsWith("data:image") ||
      value.startsWith("data:video") ||
      value.startsWith("data:application/pdf")
    );

  return (
    <div
      key={key}
      className={`flex flex-col ${isMedia ? "md:col-span-2" : ""}`}
    >
      <label className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
        {formatLabel(key)}
      </label>

      {/* MEDIA PREVIEW */}
      {typeof value === "string" && value.startsWith("data:") ? (
        renderFilePreview(value, key)

      /* LINK BUTTON */
      ) : isUrl(value) ? (
    <a
  href={value}
  target="_blank"
  rel="noopener noreferrer"
  className="
    inline-flex items-center justify-center gap-2
    px-6 py-2.5
    rounded-lg
    bg-gradient-to-r from-blue-600 to-indigo-600
    text-white font-semibold text-sm
    shadow-md shadow-blue-500/25
    hover:from-blue-700 hover:to-indigo-700
    hover:shadow-lg hover:shadow-blue-500/30
    transition-all duration-200
    w-full
  "
>
  <i className="fa fa-external-link-alt text-xs"></i>
  Open Link
</a>



      /* NORMAL TEXT */
      ) : (
        <div
          className="
            px-4 py-3 rounded-lg border border-gray-300 dark:border-slate-700
            bg-gray-50 dark:bg-slate-900 text-gray-800 dark:text-gray-100 font-medium
            break-all whitespace-normal overflow-hidden
          "
        >
          {String(value)}
        </div>
      )}
    </div>
  );
})}



  </div>
              </div>

              {/* Footer with Close Button */}
              <div className="p-6 border-t border-gray-200 dark:border-slate-800 bg-gray-50 dark:bg-slate-900 rounded-b-2xl flex gap-3 justify-end">
                <button variant="outline" onClick={() => setShowForm(false)} className="px-6">
                  Close
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>


      {/* Delete Confirmation Modal */}
      <AnimatePresence>
        {showDeleteConfirm && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.9, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: 20 }}
              className="bg-white rounded-xl shadow-xl max-w-md w-full p-6"
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                  <Trash2 className="w-6 h-6 text-red-600" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">Confirm Delete</h3>
                  <p className="text-sm text-gray-500">This action cannot be undone</p>
                </div>
              </div>

              <p className="text-gray-700 mb-6">
                Are you sure you want to delete this Application? 
              </p>

              <div className="flex gap-3">
                <button
                  onClick={() => setShowDeleteConfirm(false)}
                  className="flex-1 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg font-medium transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={()=>handleDelete(deleteId)}
                  className="flex-1 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition-colors"
                >
                  Delete
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default StartupIdeas
